import { render } from "./Loading.vue?vue&type=template&id=a5002fb6&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=a5002fb6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a5002fb6"

export default script